<template>
  <v-dialog
      v-model="isModal"
      class="exhibitor-page__modal"
      max-width="588px"
      width="100%"
      persistent
  >
    <v-card class="exhibitor-page__modal">
      <div class="exhibitor-page__modal__title d-flex flex-column">
        <span v-if="error">{{error}}</span>
        <span v-else-if="isCompleted && !error">{{isComplete}}</span>
        <div class="d-flex flex-column" v-else-if="!error && !isCompleted">
          <span>Thank you!</span>
          <span>Your submission is complete.</span>
        </div>
      </div>
      <button type="button" @click="closeModal" class="exhibitor-page__modal__btn">
        OK
      </button>
    </v-card>
  </v-dialog>

</template>
<script>
import {mapActions} from "vuex";

export default {
   props: {
     isModal: {
       type: Boolean,
       default: false,
     },
     error:{
       type:String,
       default:'',
     },
     isCompleted:{
       type:Boolean,
       default:false
     }
   },
   computed: {
     isComplete(){
       return 'Your submission has already been collected.'
     }
   },
   methods:{
     ...mapActions('event',['getSurveyErrorClear']),
     closeModal() {
       this.$emit('closeModal')
       this.getSurveyErrorClear()
     }
   }
 }
</script>

<style scoped>

</style>